import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-notification-box',
  templateUrl: './notification-box.component.html',
  styleUrls: ['./notification-box.component.scss']
})
export class NotificationBoxComponent {
  @Input() public isSuccess = false;
  @Input() public isSuccess2 = false;
  @Input() public isWarning = false;
  @Input() public isDanger = false;
  @Input() public isInfo = false;
  @Input() public marginBottom = false;
  @Input() public marginTop = false;
}
